import { cloneElement, memo, useState } from 'react';
import { Typography, CircularProgress, Box, Tooltip, Icon } from '@mui/material';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';
import { byteString } from '../../functions/helperfunctions';
import FAIcon from '../FAIcon';
//import StylesWrapper from '../StylesWrapper';

const PREVIEW_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

function FilePreview({
	file,
	onClick,
	hoverIcon = <Icon>{PREVIEW_TYPES.includes(file.type) ? 'fullscreen' : 'cloud_download'}</Icon>,
	hoverIconSize,
	downloadOnClick = !PREVIEW_TYPES.includes(file.type)
}) {
	let { name, size, type, url, urlPreview } = file;
	const [lightboxImage, setLightboxImage] = useState(null);
	let Content = <div />;

	const defaultOnClick = file => {
		// Bei PDF-Dateien PDF in neuer Seite öffnen
		if (file.type === 'application/pdf') return window.open(file.url, '_blank');
		// Bild-Dateien in Lightbox öffnen
		setLightboxImage({ url: file.url, name: file.name });
	};

	// Alle Video Mime-Types
	if (/^video.*/.test(type)) type = 'VIDEO';

	switch (type) {
		case 'image/jpeg': {
			Content = <img src={url} style={{ maxWidth: '100%' }} />;
			break;
		}
		case 'image/png': {
			Content = <img src={url} style={{ maxWidth: '100%' }} />;
			break;
		}
		case 'application/pdf': {
			Content = <FAIcon sx={{ fontSize: 50 }} icon="faFilePdf" />;
			// Content = (
			// 	<Document
			// 		file={{ url }}
			// 		renderMode="svg"
			// 		loading={
			// 			<Box className="h-full w-full flex items-center justify-center">
			// 				<CircularProgress />
			// 			</Box>
			// 		}
			// 	>
			// 		<Page pageNumber={1} height={58} className="border border-1 border-slate-300" />
			// 	</Document>
			// );
			break;
		}
		case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
			Content = <FAIcon sx={{ fontSize: 50 }} icon="faFileWord" />;
			break;
		}
		case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
			Content = <FAIcon sx={{ fontSize: 50 }} icon="faFileExcel" />;
			break;
		}
		case 'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
			Content = <FAIcon sx={{ fontSize: 50 }} icon="faFilePowerpoint" />;
			break;
		}
		case 'VIDEO':
			Content = <FAIcon sx={{ fontSize: 50 }} icon="faFileVideo" />;
			break;
		default: {
			Content = <FAIcon sx={{ fontSize: 50 }} icon="faFile" />;
		}
	}

	// Wenn Link zu Vorschaubild übergeben ist, wird es statt dem eigentlichen Content angezeigt
	if (urlPreview) Content = <img src={urlPreview} style={{ maxWidth: '100%' }} />;

	return (
		<>
			<Box sx={{ width: 60, height: 80 }}>
				<Box
					// className="relative text-black flex items-center justify-center overflow-hidden rounded-4"
					sx={{ width: 60, height: 60, overflow: 'hidden', borderRadius: '4px', position: 'relative' }}
					component={downloadOnClick ? 'a' : 'div'}
					href={downloadOnClick ? url : undefined}
					download={downloadOnClick ? name : undefined}
				>
					{Content}
					<Box
						// className="absolute inset-0 flex items-center justify-center cursor-pointer opacity-0 ease-linear"
						sx={{
							position: 'absolute',
							top: '0px',
							right: '0px',
							left: '0px',
							bottom: '0px',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							cursor: 'pointer',
							backgroundColor: 'rgba(0,0,0,0.5)',
							transition: 'opacity 0.1s ease-in',
							'&:hover': {
								opacity: 1
							}
						}}
						onClick={() => {
							if (downloadOnClick) return;
							if (onClick) return onClick(file);
							defaultOnClick(file);
						}}
					>
						{hoverIcon && cloneElement(hoverIcon, { sx: { fontSize: hoverIconSize, color: '#fff' } })}
					</Box>
				</Box>
				<Tooltip title={`${name} (${byteString(size)})`} placement="top">
					<Typography type="caption" noWrap>
						{name}
					</Typography>
				</Tooltip>
			</Box>
			{Boolean(lightboxImage) && <Lightbox mainSrc={lightboxImage.url} onCloseRequest={() => setLightboxImage(null)} />}
		</>
	);
}

FilePreview.propTypes = {
	file: PropTypes.object.isRequired,
	onClick: PropTypes.func,
	hoverIcon: PropTypes.element,
	hoverIconSize: PropTypes.number,
	downloadOnClick: PropTypes.bool
};

FilePreview.defaultProps = {
	onClick: undefined,
	hoverIcon: undefined,
	hoverIconSize: 30,
	downloadOnClick: false
};

export default memo(FilePreview);
